import { baseThemeValues } from 'constants/common';

const tabBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '16px',
};

export const tabTheme = {
  active: {
    base: {
      ...tabBase,
      bg: 'palette.transparent',
      fontWeight: 600,
      text: 'palette.tertiary.95',
      underline: 'palette.primary.20',
    },
    baseProps: tabBase,
    hover: {
      ...tabBase,
      bg: 'palette.surface.5',
      fontWeight: 600,
      text: 'palette.tertiary.95',
      underline: 'palette.primary.20',
    },
    pressed: {
      ...tabBase,
      bg: 'palette.surface.4',
      fontWeight: 600,
      text: 'palette.tertiary.95',
      underline: 'palette.primary.20',
    },
  },
  inactive: {
    base: {
      ...tabBase,
      bg: 'palette.transparent',
      fontWeight: 600,
      text: 'palette.tertiary.50',
      underline: 'palette.transparent',
    },
    baseProps: tabBase,
    hover: {
      ...tabBase,
      bg: 'palette.surface.5',
      fontWeight: 600,
      text: 'palette.tertiary.95',
      underline: 'palette.transparent',
    },
    pressed: {
      ...tabBase,
      bg: 'palette.surface.4',
      fontWeight: 600,
      text: 'palette.tertiary.95',
      underline: 'palette.transparent',
    },
  },
};

export const tabsTheme = {
  borderColor: 'palette.neutral.40',
  borderWidth: '1px',
};
